import EditOffIcon from "@mui/icons-material/EditOff";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ListStateIcon } from "../ListStateIcon";

interface IListStateIconReadOnlyProps {
    readOnly: boolean
}

export const ListStateIconReadOnly = (props: IListStateIconReadOnlyProps) => {
    if (!props.readOnly) return null;
    return (
        <ListStateIcon
            tooltip={Translations.ReadOnly}
            icon={EditOffIcon}
        />
    );
};
